// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__PHCEr","label":"SetPasswdForm_label__WasSq"};